/**
 * Native homeowner signup stays off the purchase dead end.
 * Web still offers "Start my own account". CommonJS only. No object spread.
 */

const ASK_YOUR_SPONSOR_TEXT = 'Ask your sponsor to add you.';

function nativeOwnAccountAllowed(isNative) {
  return isNative !== true;
}

module.exports = {
  ASK_YOUR_SPONSOR_TEXT,
  nativeOwnAccountAllowed,
};
